import allowed from '@/core/constants/allowed-roles.constant'

const index = [
  {
    name: 'Training Management',
    path: '/safety-management',
    meta: {
      requiresAuth: true,
      layout: 'home',
      module: 'training-management',
      allowedRoles: [...allowed.training_management.roles],
    },

    children: [
      {
        name: 'Training Management Home',
        path: 'training-management',
        component: () =>
          import(
            '@/modules/training-management/containers/training-management.container.vue'
          ),
      },
    ],
  },
]

export default index
